import {CoreModule} from '@core/core.module';
import {LOCALE_ID, NgModule} from "@angular/core";
import { RouterModule } from '@angular/router';
import { AppRoutes } from './app.routing';
import {AppComponent} from './app.component';
import {AppService} from "@core/services/app.service";
import {NavService} from "@core/services/nav.service";
import {AuthService} from "@core/authentication/auth.service";
import {NotifyService} from "@shared/services/global";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {BrowserModule, provideClientHydration, withEventReplay} from "@angular/platform-browser";
import {provideHttpClient, withFetch, withInterceptorsFromDi} from "@angular/common/http";
import {BusinessI18nService} from '@core/libs/i18n';
import {HttpInterceptorProviders} from '@core/interceptors';


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    CoreModule,
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes, {
      useHash: false,
      enableTracing: false, // Debug routing log
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  providers: [
    HttpInterceptorProviders, // chặn và xử lý các HTTP request/response toàn cục
    {
      provide: LOCALE_ID,
      deps: [BusinessI18nService],
      useFactory: (businessI18nService: BusinessI18nService) => businessI18nService.getLocale(), // Lấy ngôn ngữ doanh nghiệp để Angular tự động hiển thị đúng locale.
    },
    NavService,
    AppService,
    AuthService,
    NotifyService,
    BusinessI18nService,
    provideClientHydration(withEventReplay()), // đảm bảo sự kiện ko bị mất khi tải trang
    provideHttpClient(withFetch()), // Sử dụng fetch() thay vì XHR để tối ưu HTTP requests.
    provideHttpClient(withInterceptorsFromDi()), //Angular khuyến nghị chuyển sang sử dụng API mới là provideHttpClient(withInterceptorsFromDi()) để cấu hình HttpClient cùng với các interceptor.
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
